import { useDispatch } from 'react-redux'

import { clearTenantSummary } from 'slices/dashboardSlice'
import { logout as sessionLogout } from 'slices/sessionSlice'
import { clearWorkspaceList } from 'slices/workspacesSlice'

// ログアウト時は必ずこのフックを使用する

const useLogout = () => {
  const dispatch = useDispatch()
  const logout = () => {
    dispatch(sessionLogout())
    dispatch(clearTenantSummary())
    dispatch(clearWorkspaceList())
  }
  return { logout }
}
export default useLogout
